<template>
    <div>
       <el-row class="infoLink">
            <router-link to="/my/info/basic">{{$t('myPage.userInfo')}}</router-link>
            <router-link to="/my/info/bankCard">{{$t('myPage.bank')}}</router-link>
            <router-link to="/my/info/account">{{$t('myPage.complete')}}</router-link>
        </el-row>
       <router-view></router-view>
    </div>
</template>
<script>
export default {
    
}
</script>